/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { getExternalCollaboratorEntitlementFromQuery } from '@confluence/external-collab-ui';

import type { useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery as useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data } from './__types__/useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery';

export const useIsEntitledExternalCollaborator = () => {
	const { loading, data } =
		useQuery<useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data>(gql`
			query useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery {
				entitlements {
					externalCollaborator {
						isEntitled
					}
				}
			}
		`);
	return {
		isEntitledExternalCollaboration: getExternalCollaboratorEntitlementFromQuery(data) ?? false,
		loading,
	};
};
